<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>From Robber Barons to Courtiers</h1>
<p class="titlea">The Changing World of the Lovells of Titchmarsh</p>
<p class="author">Monika E Simon</p>
<div class="image_containerp1">
<img alt="images" src="images/f0003-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?2e14d6e6